import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { SolicitudesPermisosPorRegistrarTH, PostFirmaMasivo } from "./TypesRegistroSolicitudes";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import { SolicitudVacacionesRechazoDTO } from "components/DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes";
import Swal from "sweetalert2";
import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"

async function showAlert(message, imageSrc, isSuccess) {
    Swal.fire({
        text: message,
        imageUrl: `${imageSrc}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "�xito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}
export async function ObtenerInformacionRegistros() {
    const URL = config.SERVER_URL + "AprobacionTh/Registros";
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: SolicitudesPermisosPorRegistrarTH[] | string = respuesta.data;

        if (typeof (datos) === "string") {
            resultado = { status: respuesta.status, dataResponse: datos }
        }
        else {
            const datosMapeados: SolicitudesPermisosPorRegistrarTH[] = MapearSolicitudesPermisosPorRevisar(datos)
            resultado = { status: respuesta.status, dataResponse: datosMapeados }
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export function MapearSolicitudesPermisosPorRevisar(datos: SolicitudesPermisosPorRegistrarTH[]) {
    const datosMapeados: SolicitudesPermisosPorRegistrarTH[] = datos.map((val, ind) => {
        return {
            ...val,
        }
    })
    return datosMapeados
}

export async function VistaPreviaSolicitudLicencias(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "AprobacionTh/AprobarLicencias/VistaPreviaFormulario/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return respuestaResponse
}

export async function RegistrarSolicitudLicencias(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "AprobacionTh/RegistroControl/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha validado la solicitud de permiso y/o licencia");
        await showAlert("Se ha registrado la solicitud de licencia", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);
        }
        return -1;
    }
}

export async function AnularAccionPersonalLicencia(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "AprobacionTh/AnularAPLicencia/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }

    return resultado;
}

export async function downloadExcelReport() {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }

    await fetch(config.SERVER_URL + "AprobacionTh/Registros/Reporte", {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser?.token}`
        },
    })
        .then(response => {
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "Reporte Solicitudes por Registrar"
                a.click();
            });
        })
        .catch((error) => {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            switch (status_code) {
                case 0 || -1:
                    alertService.error("No se ha podido establecer contacto con el servidor");
                    break;
                case 500:
                    alertService.error("Ha ocurrido un error inesperado");
                    break;
                default:
                    alertService.error("Ha ocurrido un error desconocido");
                    break;
            }
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
            return -1
        });
    return 1
}

export async function FirmaMasivaAccionPersonal(listadoSolicitudes: SolicitudesPermisosPorRegistrarTH[]) {

    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "AprobacionTh/RegistroControl/Masiva";

    const listadoIdSolicitudes: PostFirmaMasivo[] = listadoSolicitudes.map((s, i) => {
        return {
            idsolicitud: s.idPermiso
        }
    })
    try {
        const respuesta = await axios.post(URL, { listadoSolicitudes: listadoIdSolicitudes },
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const respuestaAprobacionMasiva: string[] = respuesta.data;

        if (respuestaAprobacionMasiva.length > 0) {
            const mensajesProblemas = respuestaAprobacionMasiva.map((mensaje, indimensaje) => {
                return mensaje + "\n";
            })
            await showAlert(mensajesProblemas, ErrorSVG, false);
        }
        else {
            await showAlert("Todas las acciones de personal fueron registradas", ExitoSVG, true);
        }
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            await showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }
    }
    return 1;
}